// src/components/modal/dialog-offset.tsx
import { useLayoutEffect } from "@react-aria/utils";
var DialogOffset = () => {
  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  const bodyPaddingRight = parseInt(
    document.documentElement.style.paddingRight || "0px"
  );
  const offsetMarginRight = Math.max(scrollbarWidth, bodyPaddingRight);
  useLayoutEffect(() => {
    const elements = Array.from(
      document.getElementsByClassName(
        "js-dialog-offset"
      )
    );
    elements.forEach((element) => {
      element.style.marginRight = `${offsetMarginRight}px`;
    });
    return () => {
      const elements2 = Array.from(
        document.getElementsByClassName(
          "js-dialog-offset"
        )
      );
      elements2.forEach((element) => {
        element.style.marginRight = "0px";
      });
    };
  }, []);
  return null;
};

export {
  DialogOffset
};
